export enum Kpi {
  FavourableUp,
  FavourableDown,
  Stable,
  UnfavourableUp,
  UnfavourableDown
}
